export default "__VITE_ASSET__fe2316cb__"